import { refreshTokenWrapper } from "../api/axiosClient";
import { checkIsJibri } from "../app/functions.any";
import { getCurrentConference } from "../base/conference/functions";
import { JitsiConferenceEvents } from "../base/lib-jitsi-meet";
import StateListenerRegistry from "../base/redux/StateListenerRegistry";
import { setWhiteboardInfo, setWhiteboardOpen, setWhiteboardUrl } from "./actions.any";
import { isWhiteboardVisible } from "./functions";
const OPEN_WHITEBOARD = 'open-whiteboard';
const CLOSE_WHITEBOARD = 'close-whiteboard';
StateListenerRegistry.register(state => getCurrentConference(state), (conference, { dispatch, getState }, previousConference) => {
    if (conference && conference !== previousConference) {
        const receiveMessage = async (_, data) => {
            switch (data.type) {
                case OPEN_WHITEBOARD: {
                    if (!checkIsJibri()) {
                        const token = await refreshTokenWrapper();
                        dispatch(setWhiteboardUrl(`${data?.whiteboard_url}?lang=${window.localStorage.getItem('language')}&token=${token}`));
                    }
                    else {
                        dispatch(setWhiteboardUrl(`${data?.whiteboard_url}`));
                    }
                    dispatch(setWhiteboardInfo({
                        openUsername: data?.sender_name,
                        openUserId: +data?.sender_user_id,
                        openOccupantId: data?.sender_id
                    }));
                    const _toggled = isWhiteboardVisible(getState());
                    dispatch(setWhiteboardOpen(!_toggled));
                    break;
                }
                case CLOSE_WHITEBOARD: {
                    dispatch(setWhiteboardUrl(undefined));
                    dispatch(setWhiteboardInfo({
                        openUsername: undefined,
                        openUserId: undefined,
                        openOccupantId: undefined
                    }));
                    const _toggled = isWhiteboardVisible(getState());
                    dispatch(setWhiteboardOpen(!_toggled));
                    break;
                }
            }
        };
        conference.on(JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, receiveMessage);
        conference.on(JitsiConferenceEvents.NON_PARTICIPANT_MESSAGE_RECEIVED, receiveMessage);
    }
});
